const action = {
    sign_in: 'ورود',
    continue: 'ادامه',
    continue_as: 'ادامه به عنوان {{name}}',
    create_account: 'ایجاد حساب کاربری',
    create_account_without_linking: 'ایجاد حساب جدید',
    create: 'ایجاد',
    enter_passcode: 'وارد کردن کد تأیید',
    confirm: 'تأیید',
    cancel: 'لغو',
    save_password: 'ذخیره رمز عبور',
    bind: 'اتصال به {{address}}',
    bind_and_continue: 'اتصال و ادامه',
    back: 'بازگشت',
    nav_back: 'بازگشت',
    nav_skip: 'رد کردن',
    agree: 'موافقم',
    got_it: 'متوجه شدم',
    sign_in_with: 'ادامه با {{name}}',
    forgot_password: 'رمز عبور خود را فراموش کرده‌اید؟',
    switch_to: 'تغییر به {{method}}',
    sign_in_via_passcode: 'ورود با کد تأیید',
    sign_in_via_password: 'ورود با رمز عبور',
    sign_in_via_passkey: 'ورود با کلید عبور',
    change: 'تغییر {{method}}',
    link_another_email: 'اتصال ایمیل دیگر',
    link_another_phone: 'اتصال شماره تلفن دیگر',
    link_another_email_or_phone: 'اتصال ایمیل یا شماره تلفن دیگر',
    show_password: 'نمایش رمز عبور',
    copy: 'کپی',
    verify_via_passkey: 'تأیید با کلید عبور',
    reset_password_via_passkey: 'بازنشانی رمز عبور با کلید عبور',
    download: 'دانلود',
    remove: 'حذف',
    edit: 'ویرایش',
    save: 'ذخیره',
    single_sign_on: 'ورود یکپارچه',
    authorize: 'مجوز دادن',
    use_another_account: 'استفاده از حساب دیگر',
    back_to_current_account: 'بازگشت به حساب فعلی',
    done: 'انجام شد',
};
export default Object.freeze(action);
